import KlaviyoForm from '@klv/atoms/klaviyo-form';
import HubspotForm from '@klv/atoms/hubspot-form';
import Demo from '@klv/organisms/form/demo';
import { generateClassName, getColorVariantFromBackground } from '@klv/shared/utils/functions';
import * as formStyles from '@klv/organisms/form/styles/forms.module.scss';

import { SignupForm } from './SignupForm';

import type { IHeroFormsProps } from '../../types';

const HeroForms = ({
  embeddedForm,
  modalState,
  hasForm,
  formId,
  background,
  backgroundColor,
  embeddedFormBodyCopy,
  embeddedFormHeadline,
  embeddedFormHeaderSubText,
  hubspotRedirectUrl,
  hubspotSubheaderText,
  hubspotHeaderText,
  demoFormHeader,
  demoFormRedirectUrl,
  demoFormSettings,
  formState,
  setFormState,
  showAgencyFields,
  hasContent,
}: IHeroFormsProps) => {
  if (modalState.visibleModalId) {
    return null;
  }

  if (embeddedForm === 'kform' && hasForm && formId) {
    return (
      <div className={generateClassName(['inHeroContainer', formStyles.inHeroContainer])}>
        <KlaviyoForm formId={formId} />
      </div>
    );
  }

  if (embeddedForm === 'hubspotform' && hasForm && formId) {
    return (
      <div className={generateClassName(['inHeroContainer', formStyles.inHeroContainer])}>
        <HubspotForm 
          redirectUrl={hubspotRedirectUrl} 
          hubspotSubheaderText={hubspotSubheaderText} 
          hubspotHeaderText={hubspotHeaderText} 
          backgroundColor={getColorVariantFromBackground(background)} 
          formId={formId} 
        />
      </div>
    );
  }

  if (['signup', 'signupTest', 'signupTwoColumn', 'signupInvisibleReCaptcha', 'signupSimple'].includes(embeddedForm)) {
    return (
      <SignupForm
        embeddedForm={embeddedForm}
        backgroundColor={backgroundColor}
        embeddedFormBodyCopy={embeddedFormBodyCopy}
        formState={formState}
        fullWidth={!hasContent}
        embeddedFormHeadline={embeddedFormHeadline}
        setFormState={setFormState}
        showAgencyFields={showAgencyFields}
      />
    );
  }

  if (['demo', 'demoHubSpot'].includes(embeddedForm)) {
    return (
      <Demo
        backgroundColor={backgroundColor}
        bodyCopy={embeddedFormHeaderSubText || embeddedFormBodyCopy}
        demoFormHeader={demoFormHeader}
        demoFormRedirectUrl={demoFormRedirectUrl}
        formState={formState}
        headline={embeddedFormHeadline}
        inHero={true}
        setFormState={setFormState}
        settings={demoFormSettings}
        templateName="Default"
        demoType={embeddedForm === 'demoHubSpot' ? 'demoHubSpot' : 'default'}
      />
    );
  }

  return null;
};

export default HeroForms;
